module.exports = __webpack_public_path__ + "media/images/emblems/Milvignes-blazon-a4f12c57493d3e5e5583760248734a1e.svg";